import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import NoticiasApi from '../../services/robinhood/NoticiasApi';

export default function NoticiasAlertButton(props) {
    const [noticia, setNoticia] = useState(localStorage.getItem('noticia') ? JSON.parse(localStorage.getItem('noticia')) : { id: 0 });
    const [noticias, setNoticias] = useState([{ id: 0, titulo: null }]);
    const [notificar, setNotificar] = useState(false);
    const location = useLocation();


    useEffect(() => {
        getNoticias();
    }, []);

    const getNoticias = async () => {
        await new NoticiasApi().ultimas(3).then(response => {
            response.map(item => {
                if (parseInt(item.id) > parseInt(noticia.id)) {
                    setNotificar(true);
                }
            });
        });
    }

    return (
        <>
            {notificar ?
                <li>
                    <Link to="/noticias" className="" style={{ color: location.pathname == '/noticias' ? '#dd5e89' : '' || location.pathname == '/noticias/periodo' ? '#dd5e89' : '' }} onClick={() => setNotificar(false)}  >
                        <i className="zmdi zmdi-dot-circle-alt">
                            <span className="spanSmall">  PUBLICAÇÕES  </span> <span className='zmdi zmdi-notifications-active animated infinite pulse m-t-1' style={{ color: 'gold', marginLeft: '20px' }}></span>
                        </i>
                    </Link>
                </li >
                :
                <li>
                    <Link to="/noticias" className="" style={{ color: location.pathname == '/noticias' ? '#dd5e89' : '' || location.pathname == '/noticias/periodo' ? '#dd5e89' : '' }} onClick={() => setNotificar(false)}  >
                        <i className="zmdi zmdi-dot-circle-alt">
                            <span className="spanSmall">  PUBLICAÇÕES  </span>
                        </i>
                    </Link>
                </li>
            }

        </>
    );
}